import React from 'react';
import { ChannelBox, ChannelLogo } from 'planby';

export const ChannelItem = ({ isVerticalMode, channel }) => {
  const { position, logo, title } = channel;

  return (
    <ChannelBox data-testid="sidebar-item" isVerticalMode={isVerticalMode} {...position}>
      {/* <ChannelLogo src={logo} alt="Logo" /> */}
      {title}
    </ChannelBox>
  );
};
